import { render, staticRenderFns } from "./AutoSuggestLanguage.vue?vue&type=template&id=2160e903&"
import script from "./AutoSuggestLanguage.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports